import cn from 'classnames/bind';
import Head from 'next/head';
import { SEO } from 'ui';
import jsonLdContactPage from 'utils/jsonLd/contactPage';

import ContactUsSection from '../../layouts/ContactUs/ContactUsSection';

import s from './Contact.module.scss';


const cx = cn.bind(s);

const meta = {
  title: 'Contact us',
  description: "If you have any questions, issues, or suggestions, we’ll be happy to help! Find out how to contact us via email, phone, or contact form.",
}

const Contact = ({jsonLd}) => (
  <>
    <Head>
      <script
        type="application/ld+json"
        key="product-jsonld"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd)
        }}
      />
    </Head>
    <SEO title={meta.title} description={meta.description} />
    <ContactUsSection className={cx('wrapper')} formTitle="Get in touch" />
  </>
);

Contact.prettyName = 'Contact';

export default Contact;



export const getStaticProps = async () => {
  const jsonLd  = jsonLdContactPage

  return {
    props: {
      jsonLd
    }
  };
};